"use client";

import Link from "next/link";

const navLinks = [
    {
        label: "Explore",
        items: [
            { name: "Events", href: "/events" },
            { name: "Hosts", href: "/hosts" },
        ],
    },
    {
        label: "Company",
        items: [
            { name: "About", href: "/about" },
            { name: "Contact", href: "/contact" },
        ],
    },
    {
        label: "Legal",
        items: [
            { name: "Privacy", href: "/legal/privacy" },
            { name: "Terms", href: "/legal/terms" },
            { name: "Refund Policy", href: "/refund" },
        ],
    },
];

const socialLinks = [
    { label: "IG", href: "https://instagram.com/hopp.co.in", full: "Instagram" },
];

export function FooterSection() {
    return (
        <footer className="border-t border-white/10 bg-black px-4 py-12 pb-[max(3rem,env(safe-area-inset-bottom))] sm:px-6 sm:py-16 md:px-12 md:py-20 lg:px-24">
            <div className="mx-auto max-w-5xl">
                {/* Main footer content */}
                <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
                    {/* Logo and tagline */}
                    <div>
                        <Link href="/" className="group inline-block">
                            <span className="font-heading text-3xl font-bold text-[#EDEDED] transition-colors group-hover:text-white">
                                HOPP
                            </span>
                        </Link>
                        <p className="mt-3 max-w-xs text-sm leading-relaxed text-[var(--hopp-muted)]">
                            The platform for people who actually go places.
                        </p>
                    </div>

                    {/* Navigation */}
                    <nav className="flex flex-wrap gap-8 sm:gap-12 md:gap-16">
                        {navLinks.map((section) => (
                            <div key={section.label}>
                                <h3 className="mb-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-[var(--hopp-muted)]">
                                    {section.label}
                                </h3>
                                <ul className="space-y-3">
                                    {section.items.map((item) => (
                                        <li key={item.name}>
                                            <Link
                                                href={item.href}
                                                className="text-sm text-[#EDEDED]/80 transition-colors hover:text-[#EDEDED]"
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </nav>
                </div>

                {/* Bottom bar */}
                <div className="mt-16 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
                    {/* Social links */}
                    <div className="flex items-center gap-3">
                        {socialLinks.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/5 text-xs font-semibold text-[#EDEDED]/60 transition-all hover:border-white/30 hover:text-[#EDEDED] hover:bg-white/10"
                                aria-label={link.full}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>

                    {/* Copyright */}
                    <p className="text-xs text-[var(--hopp-muted)]">
                        © {new Date().getFullYear()} HOPP. All rights reserved.
                    </p>
                </div>
                <div className="mt-8 flex flex-col items-center gap-3 text-center">
                    <p className="text-[10px] uppercase tracking-[0.35em] text-[var(--hopp-muted)]">
                        Payment methods
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-3">
                        <div className="flex h-9 items-center gap-2 rounded-full border border-[var(--hopp-panel-strong)] bg-[var(--hopp-panel)] px-3 text-[10px] font-semibold text-[var(--hopp-text)]/80">
                            <span className="text-[11px] font-bold tracking-[0.2em]">VISA</span>
                        </div>
                        <div className="flex h-9 items-center gap-2 rounded-full border border-[var(--hopp-panel-strong)] bg-[var(--hopp-panel)] px-3 text-[10px] font-semibold text-[var(--hopp-text)]/80">
                            <svg viewBox="0 0 36 16" className="h-4 w-9" aria-hidden="true">
                                <circle cx="12" cy="8" r="6" fill="#EB001B" />
                                <circle cx="20" cy="8" r="6" fill="#F79E1B" fillOpacity="0.9" />
                            </svg>
                            Mastercard
                        </div>
                        <div className="flex h-9 items-center gap-2 rounded-full border border-[var(--hopp-panel-strong)] bg-[var(--hopp-panel)] px-3 text-[10px] font-semibold text-[var(--hopp-text)]/80">
                            <svg
                                viewBox="0 0 24 24"
                                className="h-4 w-4"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                aria-hidden="true"
                            >
                                <path d="M3 10h18" />
                                <path d="M5 10V7l7-3 7 3v3" />
                                <path d="M5 10v8M9 10v8M15 10v8M19 10v8" />
                                <path d="M3 18h18" />
                            </svg>
                            Bank
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
